import { LOGO_URL } from "../../constants/brand";

export function RotatingShieldLogo({ size = 56, className = "" }) {
  return (
    <img
      src={LOGO_URL}
      alt="Iron Gate Consulting"
      data-testid="rotating-shield-logo"
      className={`igc-shield-spin ${className}`}
      style={{ width: size, height: size }}
      draggable="false"
    />
  );
}
